/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useMemo, useRef, useState } from 'react'
import { useDrag } from '@use-gesture/react'
import { useThree } from '@react-three/fiber'
import { useDispatch } from 'react-redux'
import debounce from 'lodash.debounce';

import * as actionCreator from '../../../../action/index';
import { params, const_var } from '../../../../redux/reducers/reducer';

import Wall from './Wall'
import Roof from './Roof'
import Legs from './Legs'
import OutLineSection from '../FrontLean/OutLineSection';
import Storage from './Storage';
import WallName from './WallName';
import FrontLeanToMeasurement from '../../Measurements/LeanToMeasurement/FrontLeanToMeasurement';
import { controls } from '../../../../redux/reducers/common/eventReducer';
import DoorWindows from '../../DoorWindows';

const FrontLean = ({ overlapTrussArr, setOverlapTrussArr, normalMap, envMap }) => {
    const ref = useRef();
    const dispatch = useDispatch();
    const get = useThree((state) => state.get)
    const [isDragable, setIsDragable] = useState(true);
    const [position, setPosition] = useState(params.leanF_p_pos);
    const [startPosition, setStartPosition] = useState(params.leanF_p_pos);
    const [isFrontLeanDragging, setIsFrontLeanDragging] = useState(false);
    const [dragging, setDragging] = useState(false);
    const [isHovered, setIsHovered] = useState(false)
    const [overHangWidth, setOverHangWidth] = useState(0);
    const [overHangLength, setOverHangLength] = useState(0);
    const [offSetRoofTrussH, setOffSetRoofTrussH] = useState(0)
    const [offSetRoofTrussV, setOffSetRoofTrussV] = useState(0)
    const [rightWrapSize, setRightWrapSize] = useState(0)
    const [leftWrapSize, setLeftWrapSize] = useState(0)
    const [leanToTrussPosArr, setLeanToTrussPosArr] = useState([])
    const [previousLenght, setPreviousLenght] = useState(0)

    const prvLeanF_p_d = useMemo(() => {
        ref.current = params.leanF_p_d;
        const prvLeanF_p_d = ref.current
        return prvLeanF_p_d    
    }, [params.leanF_p_d])


    const camPosZ = const_var.camera?.position?.z;

    let offset = 1
    if(camPosZ >= 0) offset = 1;
    else if(camPosZ < 0) offset = -1;

    const minLimit = -params.p_w / 2 + params.leanF_p_d / 2
    const maxLimit = params.p_w / 2 - params.leanF_p_d / 2

    const bind = useDrag(
        ({ down, delta, first, event, movement: [mx, my] }) => {
            if (controls.isCheckActiveTab === 'doorwindow' ? (const_var.focusedSection === "frontlean" && params.activeWall !== "F_L_R_S_W" && params.activeWall !== "F_L_L_S_W") : true) {
                event.stopPropagation();
            }

            if (controls.isCheckActiveTab === 'leantos' && !params.add_left_front_lean_porch && !params.add_right_front_lean_porch) {
                if (first) {
                    setStartPosition(position);
                }

                if (down === true) {
                    const distance = (const_var.controls!=undefined && const_var.controls.getDistance!=undefined)?const_var.controls.getDistance([0, 0, 0]):[0, 0, 0];
                    let distanceValue = distance - params.p_d / 2;
                    const_var.controls.enableRotate = false;
                    
                    if (isDragable) {
                        get().gl.domElement.style.cursor = 'move';
                        const nextPosition = startPosition + (mx * offset) * (distanceValue / 1000);
                        if (nextPosition < minLimit) {
                            setPosition(minLimit)
                        } else if (nextPosition > maxLimit) {
                            setPosition(maxLimit)
                        } else {
                            setPosition(nextPosition);
                        }
                    }
                    setDragging(true);
                } else {
                    setIsDragable(false);
                    const_var.controls.enableRotate = true;

                    dispatch(actionCreator.changeLeanDragState(true));
                    setIsFrontLeanDragging(true);
                    
                    // const sideArray = const_var.newDoorsArray.filter((item) => item.userData.wallName === 'F_L_F_W' || item.userData.wallName === 'F_L_F_S_W');
                    // sideArray.map((item) => {
                    //     dispatch(actionCreator.updateDoorWindowPosition(item.uniqueId, item.positionX + (position - startPosition)));
                    // })

                    const updatedNewDoorArr = const_var.newDoorsArray.map((item) => {
                        if (item.userData.wallName === 'F_L_F_W' || item.userData.wallName === 'F_L_F_S_W') {
                            return {
                                ...item,
                                positionX: item.positionX + (position - startPosition),
                                minLimitX: item.minLimitX + (position - startPosition),
                                maxLimitX: item.maxLimitX + (position - startPosition)
                            }
                        }
                        return item;
                    })
                    if (JSON.stringify(const_var.newDoorsArray) !== JSON.stringify(updatedNewDoorArr)) {
                        dispatch(actionCreator.updateDoorWindowsArray(updatedNewDoorArr, true));
                    }

                    dispatch(actionCreator.updateLeanToPosition('front', position))
                    if (position === minLimit) {
                        dispatch(actionCreator.changeLeantoPosition({event: 2, value: 'front'}))
                    } else if (position === maxLimit) {
                        dispatch(actionCreator.changeLeantoPosition({event: 3, value: 'front'}))
                    } else if (position === 0) {
                        dispatch(actionCreator.changeLeantoPosition({event: 1, value: 'front'}))
                    } else {
                        dispatch(actionCreator.changeLeantoPosition({event: 4, value: 'front'}))
                    }

                    setPreviousLenght(`${params.p_w}${params.leanF_p_d}`)
                    setStartPosition(position);
                    setDragging(false)

                    if(position !== startPosition && !dragging){
                        setPosition(startPosition)
                    } else {
                        setPosition(position)
                    }

                    debounceForDragLean()
                }
            }
        },
        { pointerEvents: true }
    );

    const debounceForDragLean = debounce(() => {
        setTimeout(() => {
            setIsDragable(true)
            get().gl.domElement.style.cursor = 'auto'
            clearTimeout();
        }, [750])
    }, [750])
    
    useMemo(() => {
        let pos = 0;

        if( Number(params.leantoAlignmentFront) === 1 ) pos = 0;
        else if( Number(params.leantoAlignmentFront) === 2 ) pos = -params.p_w/2 + params.leanF_p_d/2;
        else if( Number(params.leantoAlignmentFront) === 3 ) pos = params.p_w/2 - params.leanF_p_d/2;
        else if( Number(params.leantoAlignmentFront) === 4) {
            if (previousLenght !== `${params.p_d}${params.leanF_p_w}` && !params.apiCallAfterEdit) {
                if (position <= minLimit) {
                    pos = minLimit;
                    dispatch(actionCreator.changeLeantoPosition({event: 2, value: 'front'}))
                } else if (position >= maxLimit) {
                    pos = maxLimit;
                    dispatch(actionCreator.changeLeantoPosition({event: 3, value: 'front'}))
                } else if (position === 0 || params.leanF_p_w === params.p_d) {
                    pos = 0;
                    dispatch(actionCreator.changeLeantoPosition({event: 1, value: 'front'}))
                } else pos = position;
            } else pos = position;
        }

        if (!isFrontLeanDragging || params.add_front_lean) {
            let sideArray;
            // if( Number(params.leantoAlignmentFront) === 2 || Number(params.leantoAlignmentFront) === 3){
            //     sideArray = const_var.newDoorsArray.filter((item) => item.userData.wallName === 'F_L_F_S_W');
            // } else {
                sideArray = const_var.newDoorsArray.filter((item) => item.userData.wallName === 'F_L_F_W' || item.userData.wallName === 'F_L_F_S_W');
            // }

            sideArray.map((item) => {
                dispatch(actionCreator.updateDoorWindowPosition(item.uniqueId, item.positionX + (pos - startPosition)));
            })
            // if (JSON.stringify(const_var.newDoorsArray) !== JSON.stringify(updatedNewDoorArr)) {
            //     dispatch(actionCreator.updateDoorWindowsArray(updatedNewDoorArr, true));
            // }
            
            setStartPosition(pos);
            setPosition(pos);
            if(!params.apiCallAfterEdit) dispatch(actionCreator.updateLeanToPosition('front', pos))
        }
    }, [Number(params.leantoAlignmentFront), params.leanF_p_d, params.add_left_front_lean_porch, params.add_right_front_lean_porch, params.p_w, params.leanF_p_pos])
    
    useMemo(() => {
        if (params.add_front_lean && (!params.add_left_front_lean_porch || !params.add_right_front_lean_porch)) {
            dispatch(actionCreator.changeLeanDragState(true));      
            setIsFrontLeanDragging(true)
        } else {
            setIsFrontLeanDragging(false)
        }
    }, [Number(params.leantoAlignmentFront), params.add_front_lean, params.add_left_front_lean_porch, params.add_right_front_lean_porch])

    useMemo(() => {
        dispatch(actionCreator.changeLeanDragState(false));
        setIsFrontLeanDragging(false)
        setPosition(params.leanF_p_pos);
    }, [params.leanF_p_pos, Number(params.leantoAlignmentFront)])

    useMemo(() => {
        const offset = 0.15;
        if (params.p_r_s === 1) {
            setOverHangWidth(0.8 + offset)
            setOverHangLength(0.25 + offset)
            setOffSetRoofTrussH(0.25)
            setOffSetRoofTrussV(0.1)
        } else if (params.p_r_s === 2) {
            setOverHangWidth(0.8 + offset)
            setOverHangLength(0.3 + offset)
            setOffSetRoofTrussH(0.4)
            setOffSetRoofTrussV(0.25)
        } else if (params.p_r_s === 3) {
            setOverHangWidth(0.8 + offset)
            setOverHangLength(0.5 + offset)
            setOffSetRoofTrussH(0.4)
            setOffSetRoofTrussV(0.25)
        }

        if (params.p_r_s !== 1) {
            if (params.o_v_h_n_g) {
                setOverHangLength(prev => prev + 0.7)
            } else {
            }
            if (params.o_v_h_n_g_e) {
                setOverHangWidth(prev => prev + 0.2)
            } else {
            }
        }
    }, [params.p_r_s, params.o_v_h_n_g_e, params.o_v_h_n_g])

    useMemo(() => {
        if(params.add_right_front_lean_porch || (params.add_left_front_lean_porch && params.add_right_front_lean_porch)){
            setRightWrapSize(params.leanR_p_w)
        } else {
            setRightWrapSize(0)
        }
    }, [params.add_right_front_lean_porch, params.add_left_front_lean_porch, params.leanR_p_w])

    useMemo(() => {
        if(params.add_left_front_lean_porch || (params.add_left_front_lean_porch && params.add_right_front_lean_porch)){
            setLeftWrapSize(params.lean_p_w)
        } else {
            setLeftWrapSize(0)
        }
    }, [params.add_left_front_lean_porch, params.add_right_front_lean_porch, params.lean_p_w])

    useMemo(() => {
        if(params.add_front_lean) {
            dispatch(actionCreator.setLeanToTrussPosInfo({
                data: { frontLeanTo: leanToTrussPosArr }
            }));
        } else {
            dispatch(actionCreator.setLeanToTrussPosInfo({
                data: { frontLeanTo: [] }
            }));
        }
    }, [leanToTrussPosArr, params.add_front_lean, params.add_left_front_lean_porch, params.add_right_front_lean_porch ])

    return (
        <group 
            name='frontlean' 
            position={[position, 0, 0]}
            {...bind()}
            
            onPointerOver={() => { if ((controls.isCheckActiveTab === 'leantos') && const_var.controls.enableRotate) setIsHovered(true) }}
            onPointerOut={() => setIsHovered(false)}
        >
            { (params.p_b_c_b_f_f !== "Open" || params.p_b_c_b_f_b !== "Open" || params.p_b_c_b_f_l !== "Open" || params.add_storage_check) && <Wall /> }
            <Roof />
            <Legs overlapTrussArr={overlapTrussArr} normalMap={normalMap} envMap={envMap} setLeanToTrussPosArr={setLeanToTrussPosArr} dragging={dragging} />
            
            <group position={dragging ? undefined : [-position, 0, 0]}>
                <DoorWindows overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} section="frontlean" />
            </group>

            {params.add_storage_check_front && <Storage normalMap={normalMap} envMap={envMap}/>}

            {const_var.callMesure && 
                <>
                    <WallName />
                    <FrontLeanToMeasurement color='#2F7CBF' />
                </>
            }
            {(isHovered || dragging) && controls.isCheckActiveTab === 'leantos' && !(params.add_left_front_lean_porch || params.add_right_front_lean_porch) && <OutLineSection leftWrapSize={leftWrapSize} rightWrapSize={rightWrapSize} overHangWidth={overHangWidth} overHangLength={overHangLength} offSetRoofTrussH={offSetRoofTrussH} offSetRoofTrussV={offSetRoofTrussV}/>}
        </group>
    )
}

export default FrontLean